<div class="risk-recheck-holder">
  <div class="flex-container">
    <div class="flex-row flex-justify-center">
      <div class="flex-col-4 flex-col-md-6 flex-col-sm-12">
        <h2 class="main-title">{{ 'new_strategy.notifications.risk_recheck.title' | translate }}</h2>
        <p>{{ 'new_strategy.notifications.risk_recheck.p' | translate }}</p>
      </div>
    </div>

    @if (isEve2) {
      @if (currentAccount?.kind === '3b' || currentAccount?.kind === 'kid') {
        <app-setup-risk-ch [recheck]="true"></app-setup-risk-ch>
      }
      @if (currentAccount?.kind === '3a') {
        <app-setup-risk-3a [recheck]="true"></app-setup-risk-3a>
      }
    } @else {
      @if (currentAccount?.kind === '3b' || currentAccount?.kind === 'kid') {
        <app-strategy-ch-risk [recheck]="true"></app-strategy-ch-risk>
      }
      @if (currentAccount?.kind === '3a') {
        <app-strategy-3a-risk [recheck]="true"></app-strategy-3a-risk>
      }
    }
  </div>
</div>
